<template>
  <div class="row mb-4">
    <div class="form-inline col">
      <div class="input-group">
        <!-- Not using v-model for live search as we need mobile browsers to update -->
        <input
          type="text"
          class="form-control ml-4"
          placeholder="Search"
          :value="$parent.searchtext"
          @input="$parent.searchtext = $event.target.value"
          @keydown.esc="$parent.searchtext=''"
          ref="search"
        />
        <div class="input-group-append">
          <button class="btn btn-light" @click="$parent.searchtext='';$refs.search.focus()">
            <span v-if="$parent.reloadTimer" class="spinner-border spinner-border-sm input-loading"></span>
            <i v-else class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col text-right">
      <slot></slot>
      <router-link v-for="b in buttons" :to="b.to" :accesskey="b.accesskey" :key="b.to" class="btn btn-primary ml-4">
        <i v-if="b.fa" :class="'fa fa-' + b.fa"></i>
        <span v-if="b.text" class="d-none d-sm-inline-block ml-5">
          {{ b.text }}
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        buttons: {
            type: Array,
        }
    }
}
</script>